import { useMutation, useQueryClient } from "@tanstack/react-query";
import { apiPost, ApiError } from "../api/client";

interface ChangePasswordPayload {
  current_password: string;
  new_password: string;
}

interface ChangeResponse {
  ok: boolean;
  code: string;
}

export function useChangePassword() {
  const qc = useQueryClient();
  return useMutation<ChangeResponse, ApiError, ChangePasswordPayload>({
    mutationFn: (p) => apiPost<ChangeResponse>("/api/auth/pm/change-password", p),
    onSuccess: () => qc.invalidateQueries({ queryKey: ["pm-session"] }),
  });
}
